import type { MetodologiaCarbonoReferencia } from "@/config/ambiental-carbono-config";

interface MethodologyCardProps {
  methodology: MetodologiaCarbonoReferencia;
}

export default function MethodologyCard({ methodology }: MethodologyCardProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-background-100">
          <i className="ri-calculator-line text-foreground-500 text-lg" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-foreground-900 leading-tight">{methodology.name}</h3>
          <div className="text-[11px] text-foreground-500">{methodology.type} · referência</div>
        </div>
      </div>

      <p className="text-xs text-foreground-600 mb-3 leading-relaxed">{methodology.description}</p>

      <div className="space-y-2 mb-3">
        <div className="text-[11px] text-foreground-500 font-medium">Dados necessários:</div>
        <div className="flex flex-wrap gap-1.5">
          {methodology.requiredData.map((item) => (
            <span key={item} className="px-2 py-0.5 bg-background-50 text-[11px] text-foreground-600 rounded-md border border-background-200">
              {item}
            </span>
          ))}
        </div>
      </div>

      <div className="bg-background-50 rounded-lg p-2">
        <div className="text-[10px] text-foreground-400 mb-0.5">Limitação</div>
        <div className="text-xs text-foreground-600">{methodology.limitations}</div>
      </div>
    </div>
  );
}
